import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = () => {
  return (
    <div className="bg-white bg-opacity-10 backdrop-blur-sm border border-white border-opacity-20 rounded-xl p-12 text-center">
      <div className="w-16 h-16 bg-white bg-opacity-20 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="Users" size={32} className="text-blue-100" />
      </div>

      <h3 className="text-xl font-heading font-semibold text-white mb-3">
        No Character Roles Found
      </h3>

      <p className="text-blue-100 font-body mb-8 max-w-md mx-auto leading-relaxed">
        There are no character roles in the database yet. Character roles will appear here once musicals with character information are added to the system.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button
          variant="outline"
          onClick={() => window.location.href = '/all-musicals'}
          iconName="Library"
          iconPosition="left"
          className="border-blue-400 text-blue-400 hover:bg-blue-400 hover:text-white rounded-lg"
        >
          Browse Musicals
        </Button>
        
        <Button
          variant="outline"
          onClick={() => window.location.href = '/admin-home-dashboard'}
          iconName="Home"
          iconPosition="left"
          className="border-white text-white hover:bg-white hover:text-indigo-900 rounded-lg"
        >
          Go to Dashboard
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;